import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRecruiterAuth } from '../../../CompanyAdmin/Context/RecruiterAuthContext';

export default function RecruiterProtectedRoute({ children }) {
  const { isAuthenticated, checking } = useRecruiterAuth();

  if (checking) return null; // or loading spinner
  if (!isAuthenticated) return <Navigate to="/recruiter/login" replace />;

  return children;
}
